import { KeywordButtonType } from "@components/Button/utils/types";
import KeywordLimitModalVersion1 from "@components/KeywordFilter/components/KeywordLimitModal/KeywordLimitModalVersion1";
import KeywordLimitModalVersion2 from "@components/KeywordFilter/components/KeywordLimitModal/KeywordLimitModalVersion2";

export const KeywordLimitModalFactory = ({
  keywordButtonType = KeywordButtonType.default,
}) => {
  switch (keywordButtonType) {
    case KeywordButtonType.version3:
      return KeywordLimitModalVersion2;

    case KeywordButtonType.version2:
    default:
      return KeywordLimitModalVersion1;
  }
};
